import { Box } from '@redbubble/design-system';
import React, { ReactNode } from 'react';
import styles from './TabList.module.scss';

interface TabListProps {
  children?: ReactNode;
}

const TabList = ({ children }: TabListProps) => {
  return (
    <Box className={styles.container} marginTop="m">
      {children}
    </Box>
  );
};

export default TabList;
